import { get as lodashGet } from "lodash-es";
import { PermissionTypes } from "@certa/types";
import { FEATURE_FLAGS } from "main/src/modules/common/constants";
import { useCheckPermission } from "../utils/permissions/Chowkidar";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useIsProcessOverviewEnabled = (): boolean => {
  const hasWorkflowProfilePermission = useCheckPermission(
    PermissionTypes.CAN_VIEW_WORKFLOW_PROFILE
  );

  const { data: config } = useInstanceConfigQuery();
  const isProcessOverviewEnabled = lodashGet(
    config,
    "custom_ui_labels.specialFeatures",
    [""]
  ).includes(FEATURE_FLAGS.ENABLE_PROCESS_OVERVIEW);

  return isProcessOverviewEnabled && hasWorkflowProfilePermission;
};
